import { classNames } from "@/react/helpers/twMergeWithCN";
import { useIsPaywallsModalsV3 } from "@/react/hooks/useIsPaywallsModalsV3";
import { useMdScreenMediaQuery } from "@/react/hooks/useMediaQuery";
import { AllWorkflows } from "@circle-react/components/SettingsApp/Workflows/routes/AllWorkflows";
import { TabContainer } from "../../components/TabContainer";

const getPageSize = (isPaywallsModalsV3: boolean, isMdScreen: boolean) => {
  if (isPaywallsModalsV3) {
    return isMdScreen ? 4 : 3;
  }

  return 3;
};

export const WorkflowsTab = () => {
  const isPaywallsModalsV3 = useIsPaywallsModalsV3();
  const isMdScreen = useMdScreenMediaQuery();

  return (
    <TabContainer
      className={classNames({
        "-mx-6 -mt-4": isPaywallsModalsV3,
        "h-[60vh] overflow-y-auto px-2 pt-3": !isPaywallsModalsV3,
      })}
    >
      <AllWorkflows
        category="paywalls"
        pageSize={getPageSize(isPaywallsModalsV3, isMdScreen)}
      />
    </TabContainer>
  );
};
